import AutomatonCard from './AutomatonCard';

export default AutomatonCard;
